import type { Components } from 'streamdown';
import { MarkdownLink } from './MarkdownLink';
import {
  MarkdownListItem,
  MarkdownOrderedList,
  MarkdownUnorderedList,
} from './MarkdownList';
import { MarkdownSpan } from './MarkdownSpan';
import { MarkdownTable } from './MarkdownTable';
import {
  MarkdownTableBody,
  MarkdownTableCell,
  MarkdownTableHead,
  MarkdownTableHeader,
  MarkdownTableRow,
} from './MarkdownTableCells';

/** streamdown element overrides for chat markdown: kakashi-styled tables + media-aware links,
 * and lists with gutter markers that don't break onto their own line. Passed to
 * <Streamdown components={...}> in MessageResponse. */
export const CHAT_MARKDOWN_COMPONENTS: Components = {
  a: MarkdownLink,
  span: MarkdownSpan,
  ol: MarkdownOrderedList,
  ul: MarkdownUnorderedList,
  li: MarkdownListItem,
  table: MarkdownTable,
  thead: MarkdownTableHeader,
  tbody: MarkdownTableBody,
  tr: MarkdownTableRow,
  th: MarkdownTableHead,
  td: MarkdownTableCell,
};
